<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { groupWhatsAppReactions } from './helpers/whatsappReactions';

const props = defineProps({ reactions: { type: Array, default: () => [] } });
const { t } = useI18n();
const groups = computed(() =>
  groupWhatsAppReactions(props.reactions, {
    you: t('WHATSAPP_REACTIONS.YOU'),
    contact: t('WHATSAPP_REACTIONS.CONTACT'),
  })
);
</script>

<template>
  <div
    v-if="groups.length"
    class="relative z-10 flex flex-wrap gap-1 px-2 -mt-1 mb-1"
    data-testid="whatsapp-reactions"
  >
    <span
      v-for="group in groups"
      :key="group.emoji"
      role="img"
      :aria-label="`${group.emoji} — ${group.names.join(t('WHATSAPP_REACTIONS.SEPARATOR'))}`"
      :title="group.names.join(t('WHATSAPP_REACTIONS.SEPARATOR'))"
      class="inline-flex items-center gap-1 rounded-full border border-n-weak bg-n-solid-1 px-2 py-0.5 text-sm leading-5 shadow-sm ring-2 ring-n-background"
      :class="{ 'border-n-brand': group.mine }"
    >
      <span aria-hidden="true">{{ group.emoji }}</span>
      <span
        v-if="group.names.length > 1"
        class="text-xs text-n-slate-11"
        aria-hidden="true"
      >
        {{ group.names.length }}
      </span>
    </span>
  </div>
</template>
